import { useEffect, useState } from "react";
import axiosInstance from "../../../../../services/AxiosInstance";
import { ApiError } from "../../../Common/ApiError";
import Api from "../../../../../constants/Api";
import { getDateRange } from "../../../../../utils/DateUtils";
import BarChart from "../../../charts/BarChart";
import { useTranslation } from "react-i18next";

const PotBarChart = (props) => {

    const { t } = useTranslation();
    const { width, height, month, year, branchId, className, refreshKey, data: suppliedData, labels: suppliedLabels } = props;
    const [loadedData, setLoadedData] = useState([]);
    const [loadedLabels, setLoadedLabels] = useState([]);

    useEffect(() => {
        // A tela do Pote compartilha o mesmo rateio com os dois gráficos. Buscar de novo
        // aqui só duplicaria uma consulta que já veio na resposta consolidada.
        if (suppliedData) {
            return;
        }
        const dateRange = getDateRange(month, year);
        axiosInstance.get(`${Api.sales.visual_chart}/pot/interval/${dateRange.start}/${dateRange.end}/score`, {
            params: {
                branchId
            }
        })
        .then((resp) => {
            setLoadedData(resp.data.data);
            setLoadedLabels(resp.data.labels);
        })
        .catch(error => ApiError(error));
    }, [month, year, branchId, refreshKey, suppliedData]);

    return (
        <BarChart
            className={className}
            width={width}
            height={height}
            data={suppliedData || loadedData}
            labels={suppliedLabels || loadedLabels}
            datasetLabel={t('gamification.score')}
        />
    );
}

export default PotBarChart;
